<template>
    <a :href="url">
        <div class="pt-6">
            <div class="flow-root rounded-lg bg-gray-50 px-6 pb-8">
                <div class="-mt-6 min-h-[15vh] md:min-h-[10vh]">
                    <div class="mb-4">
                        <span :class="iconColor" class="inline-flex items-center justify-center rounded-md p-3 shadow-lg">
                            <span :class="icon"  class="lnr h-6 w-6 text-white"></span>
                        </span>
                    </div>
                    <span class="mt-12 text-lg font-medium tracking-tight text-gray-900">
                        <slot name="header"></slot>
                    </span>
                    <p class="mt-5 text-base text-gray-500">
                        <slot name="content"></slot>
                    </p>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
name: "GridOffsetIcon",
    props: {
        icon: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: false
        },
        color: {
            type: String,
            default: 'blue'
        }
    },
    computed: {
        iconColor(){
            if(this.color === 'blue'){
                return 'bg-blue-500';
            }
            if(this.color === 'red'){
                return 'bg-red-500';
            }
            if(this.color === 'yellow'){
                return 'bg-yellow-500';
            }
            return 'bg-gray-500';
        }
    }
}
</script>

<style scoped>

</style>